// extracted by mini-css-extract-plugin
module.exports = {"ShoppingCart":"ShoppingCart__ShoppingCart__2Rvbg","Icon":"ShoppingCart__Icon__fdCbp","Items":"ShoppingCart__Items__HNS9N"};